import {ControlBase} from './control-base';

import {HttpService} from '../../http/http.service';
import {LocatorService} from '../../base/services/locator.service';
import {filter, map} from 'rxjs/operators';
import {MyResponse} from '../../http/MyResponse.interface';

declare const tinymce: any;

export class ControlEditor extends ControlBase<string> {
    ControlType = 'editor';

    http: HttpService = LocatorService.injector.get(HttpService);

    class: string = '';
    uploadUrl = '';
    instance = null;
    config = {
        selector: `#${this.name}_editor`,
        base_url: '/tinymce',
        suffix: '.min',
        language: 'zh_CN',
        height: 300,
        placeholder: '',
        plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
        menubar: 'file edit view insert format tools table help',
        toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample',
        toolbar_sticky: true,
        image_advtab: true,
        importcss_append: true,
        image_caption: true,
        quickbars_selection_toolbar: 'bold italic | h2 h3 blockquote quickimage quicktable',
        noneditable_noneditable_class: 'mceNonEditable',
        toolbar_mode: 'sliding',
        contextmenu: 'image imagetools table',
        images_upload_handler: (blobInfo, success, failure) => {
            this.http.upload({
                action: this.uploadUrl,
                file: blobInfo.blob()
            }).pipe(
                filter(res => res.type == 4),
                map(res => res['body'])
            ).subscribe(
                (res: MyResponse) => {
                    if (res) {
                        if (res.success) {
                            success(this.http.url(res.message, false));
                        } else {
                            failure(res.message);
                        }
                    }
                },
                (err) => failure(err)
            );
        },
        setup: (editor) => {
            editor.on('keyup', () => {
                this.value = editor.getContent();
            });
            editor.on('change', () => {
                this.value = editor.getContent();
            });
        }
    };

    constructor(options: {} = {}) {
        super(options);
        this.value = (undefined != options['value']) ? options['value'] : '';
        this.placeholder = options['placeholder'] || '请输入' + (options['label'] || '');
        this.config.placeholder = this.placeholder;
        this.uploadUrl = (undefined == options['uploadUrl']) ? '' : this.http.url(options['uploadUrl']);
        this.class = (undefined == options['class']) ? this.class : options['class'];
        this.config.plugins = (undefined == options['plugins']) ? this.config.plugins : options['plugins'];
        this.config.toolbar = (undefined == options['toolbar']) ? this.config.toolbar : options['toolbar'];
        this.config.menubar = (undefined == options['menubar']) ? this.config.toolbar : options['menubar'];

        setTimeout(() => {
            this.config.selector = `#${this.name}_editor`;
            tinymce.remove();
            tinymce.init(this.config).then(res => {
                if (res) {
                    this.instance = res[0];
                }
            });
        }, 500);
    }

    refresh() {
        setTimeout(() => {
            if (this.instance && this.instance.setContent) {
                this.instance.setContent(this.value);
            }
        }, 200);
    }
}
